import { Grid } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import { getMIPEndpoint } from "../../../services/AnlagenService";
import { useHttp } from "../../../services/HttpService";
import { createColumn, createComponentColumn } from "../../../utils/ColumnUtils";
import { userHasAnyRole } from "../../../utils/SecurityUtils";
import EAAccordion from "../../EAAccordion";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import EADialog from "../../EADialog";
import EATable from "../../EATable";
import EATextField from "../../EATextField";
import { logger } from "../../../services/LogService";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import { useConfirmation } from "../../ConfirmationDialog/ConfirmationDialogProvider";
import { confirmDeleteOption } from "../../ConfirmationDialog/confirmationDialogOptions";
import {ENTLASTUNG} from "../../../consts/anlagentyp";

function TableDialog(props) {
    const [{ data, loading }] = useHttp({ url: getMIPEndpoint, timeout: 60000 });
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        if (data) {
            setFilteredData([
                ...data.filter((item) => {
                    return (
                        !filter ||
                        item.mipNr.includes(filter.toLowerCase()) ||
                        item.bezeichnung.toLowerCase().includes(filter.toLowerCase()) ||
                        item.nameMassnahmetraeger.toLowerCase().includes(filter.toLowerCase())
                    );
                }),
            ]);
        }
    }, [data, filter, loading]);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Fördermaßnahme auswählen"}
            content={
                <div style={{ width: "700px", maxHeight: "750px", minHeight: "400px" }}>
                    <div className="gridl" style={{ gridTemplateColumns: "repeat(3,auto)", paddingBottom: "8px" }}>
                        <EATextField
                            value={filter}
                            onChange={(e) => {
                                e.preventDefault();
                                setFilter(e.target.value);
                            }}
                            id="foerdermassnahmeFilter"
                            data-cy="foerdermassnahmeFilter"
                            label="Suchkriterium"
                        />
                        <div>
                            <EAButton
                                onClick={() => {
                                    setFilter("");
                                }}
                                id="foerdermassnahmeFilterSucheReset"
                                data-cy="foerdermassnahmeFilterSucheReset"
                                label="Zurücksetzen"
                            />
                        </div>
                    </div>
                    <EATable
                        id="foerdermassnahmenAuswahl"
                        initialSortColumn="mipNr"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"addFoerdermassnahme-" + index} iconName="ico-check">
                                                    <span
                                                        onClick={() => {
                                                            setFilter("");
                                                            props.onClickOk(row);
                                                        }}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                { width: "50px", padding: "0" }
                            ),
                            createColumn("mipNr", "MIP-Nr."),
                            createColumn("bezeichnung", "Maßnahme"),
                            createColumn("nameMassnahmetraeger", "Maßnahmeträger"),
                        ]}
                        data={filteredData}
                        loading={loading}
                    />
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton id={"btnAbbrechen"} data-cy={"btnAbbrechen"} label={"Abbrechen"} onClick={props.onClickCancel} />
                </EAButtonBar>
            }
        />
    );
}

TableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};

export default function Foerdermassnahmen(props) {
    const confirm = useConfirmation();
    const [extended, setExtended] = useState(true);
    const dataName = "foerderungen";
    const [dlgOpen, setDlgOpen] = useState(false);

    function handleDelete(index) {
        if (isDisabled()) {
            return;
        }

        confirm(
            confirmDeleteOption(
                "die Maßnahme",
                () => removeMassnahme(index),
                () => {}
            )
        );
    }

    function removeMassnahme(index) {
        const tableData = [...props.data];
        tableData.splice(index, 1);
        props.onChange(dataName, tableData);
    }

    function handleClose() {
        setDlgOpen(false);
    }

    function handleCloseOk(foerdermassnahme) {
        setDlgOpen(false);
        const tableData = [...props.data];
        tableData.push(foerdermassnahme);
        logger.debug(dataName + "Close", tableData);
        props.onChange(dataName, tableData);
    }

    function getRoles() {
        if (props.anlagentyp === ENTLASTUNG) {
            return [FACHADMIN, SYSTEMADMIN, ZUST_SBD, BETREIBER];
        }
        return [FACHADMIN, SYSTEMADMIN, ZUST_SBD];
    }

    function isDisabled() {
        if (props.anlegen) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole(getRoles());
        }
        return true;
    }

    return (
        <React.Fragment>
            <TableDialog open={dlgOpen} onClickCancel={handleClose} onClickOk={handleCloseOk} />
            <EAAccordion
                label={`Fördermaßnahmen (${props.data ? props.data.length : 0})`}
                className="gridl"
                id="foerdermassnahmenAccordion"
                variant="light"
                expanded={extended}
                onChange={(e, expanded) => setExtended(expanded)}
            >
                <EATable
                    id="foerdermassnahmen"
                    initialSortColumn="mipNr"
                    columns={[
                        createComponentColumn(
                            "actions",
                            (row, index) => {
                                if (isDisabled()) return <div />;
                                return (
                                    <Grid container spacing={1} justify="center">
                                        <Grid item>
                                            <EATableActionButton id={"deleteFoerdermassnahme-" + index} iconName="ico-delete">
                                                <span
                                                    onClick={() => handleDelete(index)}
                                                    className={"w-100"}
                                                    style={{
                                                        height: "100%",
                                                        display: "block",
                                                    }}
                                                />
                                            </EATableActionButton>
                                        </Grid>
                                    </Grid>
                                );
                            },
                            "",
                            null,
                            { width: "50px", padding: "0" }
                        ),
                        createColumn("mipNr", "MIP-Nr."),
                        createColumn("bezeichnung", "Maßnahme"),
                        createColumn("nameMassnahmetraeger", "Maßnahmeträger"),
                    ]}
                    data={props.data}
                />
                {props.errors && props.errors.foerderungen && (
                    <FormHelperText id="foerderungen-helper-text" error>
                        {props.errors.foerderungen}
                    </FormHelperText>
                )}
                {!isDisabled() &&
                    props.formFactory.renderButton("addFoerdermassnahme", "addFoerdermassnahme", "Hinzufügen", () => setDlgOpen(true), {
                        style: { placeSelf: "end" },
                    })}
            </EAAccordion>
        </React.Fragment>
    );
}

Foerdermassnahmen.propTypes = {
    data: PropTypes.any,
    errors: PropTypes.any,
    formFactory: PropTypes.any,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
};
